document.addEventListener('click', (event) => {
  const carouselButton = event.target.closest('[data-carousel-step]');
  if (carouselButton) {
    const section = carouselButton.closest('[data-product-carousel]');
    const scroller = section?.querySelector('[data-product-scroller]');
    if (scroller) scroller.scrollBy({ left: Number(carouselButton.dataset.carouselStep) * scroller.clientWidth * 0.8, behavior: 'smooth' });
    return;
  }
  const tabButton = event.target.closest('[data-tab-step]');
  if (!tabButton) return;
  const section = tabButton.closest('[data-category-tabs]');
  const tabs = [...(section?.querySelectorAll('[data-category-tab]') || [])];
  const active = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
  if (!tabs.length) return;
  const next = (active + Number(tabButton.dataset.tabStep) + tabs.length) % tabs.length;
  tabs[next].click();
  tabs[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
});
